export default __webpack_public_path__ + "static/media/Metropolis-Bold.757ca8be.ttf";